import { api } from './api';

export const fetchUser = () => {
  return api.get('/user/me');
};

export const login = (payload) => {
  return api.post('/auth/login', payload);
};

export const mfaVerify = (payload) => {
  return api.post('/auth/login_otp', payload);
};

export const changePassword = (payload) => {
  return api.post('/auth/password_change', payload);
};

export const refreshToken = (payload) => {
  return api.post('/auth/refresh', payload);
};

export const resendOtp = (payload) => {
  return api.post('/auth/resend_mfa_code', payload);
};

export const forgotPassword = (payload) => {
  return api.post('/auth/password_reset', payload);
};

export const confirmEmail = (params = '', payload = {}) => {
  return api.post(`/auth/email_confirm/${params}`, payload);
};

export const setPassword = (token, payload) => {
  return api.post(`/auth/password_reset/${token}`, payload);
};

export const getBastions = (email) => {
  const params = { email, user_type: ['employee'], limit: 100, page: 1 };
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get(`/auth/bastions`, payload);
};

export const logout = (data) => {
  return api.post('/auth/logout', data);
};

export const getClients = (bastion) => {
  return api.get(`/auth/clients/${bastion}`, { client_type: 'MCD' });
};

export const restoreCredentials = () => {
  const credentials = localStorage.getItem('access_token');
  if (credentials) {
    api.setHeader('Authorization', 'Bearer ' + credentials);
    return true;
  }

  return false;
};

export const storeCredentials = (credentials) => {
  localStorage.setItem('access_token', credentials);
  api.setHeader('Authorization', 'Bearer ' + credentials);
};

export const removeHeaders = () => {
  api.deleteHeader('Authorization');
};

export const storeOrganization = (org) => {
  if (org) {
    api.setHeader('Org-Slug', org);
  }
};

export const fetchLoginTransferToken = (params) => {
  return api.get('/auth/login/transfer', params);
};

export const startTwoFactor = () => {
  return api.post('/auth/mfa/start');
};

export const getTwoFactorConfiguration = () => {
  return api.get('/auth/mfa');
};

export const saveTwoFactorConfiguration = (payload) => {
  return api.patch('/auth/mfa', payload);
};

export const createIdentityProvider = (payload) => {
  return api.post('/auth/sso/identity-provider', payload);
};

export const fetchCurrentIdentityProvider = () => {
  return api.get('/auth/sso/identity-provider');
};

export const updateIdentityProvider = (payload) => {
  return api.put('/auth/sso/identity-provider', payload);
};

export const importCertificate = (payload) => {
  return api.post('/auth/sso/identity-provider/key', payload);
};
